import moment from 'moment';
import { LabelEnum } from 'app/shared/enums';

const maxDateToday = (value: string) => {
  const today = moment();
  const selectedDate = moment(value);

  return selectedDate.isSameOrBefore(today, 'day')
    ? undefined
    : LabelEnum.IncorrectDate;
};

export default maxDateToday;
